import {isExperimentOpen} from 'bolt-main/src/init/experiments/experiments'

export const name = 'ExperimentAspect'

export const functionLibrary = {
    isExperimentOpen
}
